import RemoteCall from '../../util/RemoteCall';
const remoteCall = new RemoteCall('api/nursecarecore/corpSync');

// 开启同步
const startSyncAsync = () => {
    return remoteCall.invoke("startSync");
};

// 获取同步进度
const getSyncUnitStatusAsync = () => {
    return remoteCall.invoke("getSyncUnitStatus");
};

export default {
    startSyncAsync,
    getSyncUnitStatusAsync,
};
